export class MasterDetails {
    ID:number;
CLIENT_ID:number;
ADDRESS:string;
PHONE_NO:string;
EMAIL_ID:string;
FB_LINK:string;
TWITTER_LINK:string;
SKYPE_LINK:string;
INSTA_LINK:string;
LINKED_LINK:string;
COLOR1:string;
COLOR2:string;
COLOR3:string;
COLOR4:string;
COLOR5:string;
COLOR6:string;

}